import { ChangeDetectionStrategy, Component } from '@angular/core';

import { Icono } from '../icono/icono';

/**
 * Visual de "sin imagen" del design system (FP-29). Reemplaza al SVG de casita
 * que estaba repetido inline en la tarjeta, el popup del pin y la ficha.
 *
 * Portado de `ImagePlaceholderComponent` del backoffice, recortado a lo que
 * usa el portal: allá el componente también hace avatares con iniciales y
 * badges de rol, que acá no existen porque no hay sesión (D3).
 *
 * Llena el contenedor: el tamaño lo pone quien lo usa.
 */
@Component({
  selector: 'app-placeholder-imagen',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [Icono],
  template: `<svg app-icono nombre="image-placeholder"></svg>`,
  styles: `
    :host {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
      height: 100%;
      background: var(--c-phindi-lilac_50);
      color: var(--c-phindi-lilac_600);
    }

    svg {
      /* Proporción del glifo (21×26); el alto manda para que no se deforme. */
      height: 26px;
      width: auto;
    }
  `,
})
export class PlaceholderImagen {}
